// src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './store'
import vuetify from './plugins/vuetify'

// Import Vuetify styles
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'

// Create and mount the Vue application
const app = createApp(App)

// Use plugins
app.use(router)
app.use(pinia)
app.use(vuetify)

// Mount the app
app.mount('#app')
